import { render } from "./ShiftsView.vue?vue&type=template&id=721bdea6"
import script from "./ShiftsView.vue?vue&type=script&lang=js"
export * from "./ShiftsView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__